import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const quotes = [
  { text: "The best angle is the angle you haven't peeked yet.", game: "CS2" },
  { text: "Eco today, AK tomorrow.", game: "CS2" },
  { text: "One tap. One life. One round.", game: "CS2" },
  { text: "The only bad smoke is the one you didn't throw.", game: "CS2" },
  { text: "Counter-Strike isn't a game. It's a lifestyle.", game: "CS2" },
  { text: "If you're not first, you're entry fragging wrong.", game: "CS2" },
  { text: "Every clutch starts with believing you can.", game: "CS2" },
  { text: "Don't peek. Don't peek. *Peeks* Dies.", game: "CS2" },
  { text: "The real ace was the friends we made along the way.", game: "CS2" },
  { text: "GGWP or nothing.", game: "CS2" },
];

export default function QuoteTicker() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % quotes.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const q = quotes[index];

  return (
    <div className="border-y border-white/5 bg-[#0a0a0c] py-4 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex items-center gap-4">
        <span className="font-mono text-[10px] text-[#F47B20] shrink-0 uppercase tracking-[0.2em]">
          ◈ INTEL
        </span>
        <div className="h-4 w-px bg-white/10 shrink-0" />
        <div className="relative flex-1 min-h-[20px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
              className="font-mono text-[11px] text-white/50 italic truncate"
            >
              "{q.text}"
              <span className="text-[#F47B20]/50 ml-2 not-italic">— {q.game}</span>
            </motion.div>
          </AnimatePresence>
        </div>
        <span className="font-mono text-[9px] text-white/20 shrink-0">
          {index + 1}/{quotes.length}
        </span>
      </div>
    </div>
  );
}
